import { action, makeObservable, observable } from 'mobx';
import { iframeService } from '@pascal/pascal-core';

class LoadingStore {
  timerFinished = false;

  progress = 0;

  isAdditionalLoading = false;

  gameLoading = true;

  isSoundLoaded = false; // only game needs

  isGameInitialLoaded = false; // only game needs

  isTranslationsLoaded = false;

  constructor() {
    makeObservable(this, {
      timerFinished: observable,
      progress: observable,
      gameLoading: observable,
      isSoundLoaded: observable,
      isAdditionalLoading: observable,
      isGameInitialLoaded: observable,
      isTranslationsLoaded: observable,
      updateLoading: action.bound,
      startLoaderTimer: action.bound,
      setTimerState: action.bound,
      updateIsAdditionalLoading: action.bound,
    });
  }

  updateLoading(data) {
    const newState = {
      isSoundLoaded: this.isSoundLoaded,
      isGameInitialLoaded: this.isGameInitialLoaded,
      isTranslationsLoaded: this.isTranslationsLoaded,
      ...data,
    };

    const { isSoundLoaded, isGameInitialLoaded, isTranslationsLoaded } = newState;

    this.progress = Math.ceil(
      this.calculateProgress([isSoundLoaded, isGameInitialLoaded, isTranslationsLoaded])
    );
    this.gameLoading = Math.ceil(this.progress) !== 100;

    if (!this.gameLoading) {
      iframeService.sendLoadedState();
    }

    this.isSoundLoaded = isSoundLoaded;
    this.isGameInitialLoaded = isGameInitialLoaded;
    this.isTranslationsLoaded = isTranslationsLoaded;
  }

  setTimerState(bool) {
    this.timerFinished = bool;
  }

  startLoaderTimer() {
    this.setTimerState(false);
    setTimeout(() => {
      this.setTimerState(true);
    }, 3000);
  }

  updateIsAdditionalLoading(isAdditionalLoading) {
    this.isAdditionalLoading = isAdditionalLoading;
  }

  calculateProgress(arr) {
    return arr.reduce((acc, curr, i, self) => acc + (Number(curr) / self.length) * 100, 0);
  }
}

export const loadingStore = new LoadingStore();
